import React from 'react';
import { Check } from 'lucide-react';

export function ProgressSteps({ steps, currentStep }) {
  return (
    <div className='flex items-center justify-between w-full max-w-3xl mx-auto'>
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isComplete = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;
        const isUpcoming = stepNumber > currentStep;

        return (
          <React.Fragment key={index}>
            <div className='flex flex-col items-center'>
              <div
                className={`
                  w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all
                  ${isComplete ? 'bg-green-600 text-white' : ''}
                  ${
                    isCurrent
                      ? 'bg-green-600 text-white ring-4 ring-green-100'
                      : ''
                  }
                  ${isUpcoming ? 'bg-gray-200 text-gray-500' : ''}
                `}
              >
                {isComplete ? <Check className='w-5 h-5' /> : stepNumber}
              </div>
              <div className='mt-2 text-center'>
                <p
                  className={`text-sm font-medium ${
                    isCurrent ? 'text-gray-900' : 'text-gray-500'
                  }`}
                >
                  {step.title}
                </p>
                <p className='text-xs text-gray-400 mt-1'>{step.description}</p>
              </div>
            </div>

            {index < steps.length - 1 && (
              <div className='flex-1 h-0.5 bg-gray-200 relative top-[-20px] mx-4'>
                <div
                  className={`h-full bg-green-600 transition-all duration-300 ${
                    isComplete ? 'w-full' : 'w-0'
                  }`}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
